class ArticleService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getLookupPage(params) {
    return this.apiService.get('/api/v1/articles/lookup', params);
  }

  getPage(params) {
    return this.apiService.get('/api/v1/articles', params);
  }

  getArticleDescriptions(params) {
    return this.apiService.get('/api/v1/articles/descriptions', params);
  }

  getArticleAlternatives(params) {
    return this.apiService.get('/api/v1/articles/alternatives', params);
  }

  getArticleKeywords(params) {
    return this.apiService.get('/api/v1/articles/keywords', params);
  }

  getArticlePictures(params) {
    return this.apiService.get('/api/v1/articles/pictures', params);
  }

  getAppointmentGridPage(params) {
    return this.apiService.get('/api/v1/articles/appointment-grid', params);
  }

  getActicleKeywordStructures(params) {
    return this.apiService.get('/api/v1/articles/keyword-structures', params);
  }

  getArticleKeywordAssignments(params) {
    return this.apiService.get('/api/v1/articles/keyword-assignments', params);
  }

  getQuantityScalePage(params) {
    return this.apiService.get('/api/v1/articles/quantity-scale', params);
  }
}

export default ArticleService;
